/**
 * Feature flag for the "No Action CVE".
 */
export const FEATURE_FLAG_NO_ACTION_CVE = 'noActionCVE' as const;
